import React, { Component } from "react";
import { toastr } from "react-redux-toastr";
import { Modal, Row, Col } from "react-bootstrap";
import { bool, func, object } from "prop-types";
import { FormGroup, ControlLabel, FormControl, HelpBlock } from "react-bootstrap";
import { update } from "../../utils/apiService";
import { connect } from "react-redux";

import { updateVideo } from "../../actions";

class VideoArchiveSessionsModal extends Component {
  constructor() {
    super();

    this.state = {
      session_ids_to_exclude: ""
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentWillMount() {
    let { video } = this.props;

    this.setState({ session_ids_to_exclude: video.session_ids_to_exclude });
  }

  handleChange(e) {
    this.setState({
      session_ids_to_exclude: e.target.value
    });
  }

  handleClick() {
    let { session_ids_to_exclude } = this.state;
    // console.log(video);
    console.log(this.state.session_ids_to_exclude);
    console.log(session_ids_to_exclude);

    toastr.info(`Salvando lista de sessões...`);
    let { video, updateVideo } = this.props;
    let url = `/campaigns/${video.campaign_id}/videos/${video.id}`;
    let data = {
      video: {
        session_ids_to_exclude: this.state.session_ids_to_exclude
      }
    };
    update(url, data)
      .then(res => {
        let updatedVideo = res.data;
        updateVideo(video.campaign_id, updatedVideo);
        toastr.success("Video atualizado com sucesso!");
        // this.setState({ ready: !value });
      })
      .catch(err => {
        console.log(err);
        toastr.error("Erro ao atualizar video.");
      });
  }

  render() {
    const { show, close, video } = this.props;
    return (
      <Modal show={show} onHide={close} className="modal--big">
        <Modal.Header closeButton>
          <Modal.Title>Arquivar Sessões</Modal.Title>
        </Modal.Header>
        <Modal.Body className="clearfix">
          <FormGroup controlId="formBasicText">
            <ControlLabel>Lista de IDs das sessões para serem arquivadas, separadas por vírgula:</ControlLabel>
            <FormControl
              componentClass="textarea"
              value={this.state.session_ids_to_exclude}
              placeholder={`SESSION_ID_A,\nSESSION_ID_B,\nSESSION_ID_C`}
              onChange={this.handleChange}
              rows="15"
            />
          </FormGroup>
          <FormGroup className="mt20">
            <div className="pull-right">
              <button type="submit" className="btn btn-primary" onClick={() => this.handleClick()}>
                Salvar
              </button>
            </div>
          </FormGroup>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  updateVideo: (campaignId, video) => {
    dispatch(updateVideo(campaignId, video));
  }
});

VideoArchiveSessionsModal.propTypes = {
  show: bool,
  close: func,
  video: object
};

export default connect(null, mapDispatchToProps)(VideoArchiveSessionsModal);



// WEBPACK FOOTER //
// ./src/components/modals/VideoArchiveSessionsModal.js